

const Card = ({ children, className = "", padding = true, shadow = true, border = true }) => {
  const baseStyles = "bg-white rounded-lg";
  const paddingClass = padding ? "p-6" : "";
  const shadowClass = shadow ? "shadow-sm" : "";
  const borderClass = border ? "border border-gray-200" : "";

  return <div className={`${baseStyles} ${paddingClass} ${shadowClass} ${borderClass} ${className}`}>{children}</div>;
};

export default Card;
